import { createContext, useContext } from "solid-js";
export const MenubarContext = createContext();
export function useOptionalMenubarContext() {
    return useContext(MenubarContext);
}
export function useMenubarContext() {
    const context = useOptionalMenubarContext();
    if (context === undefined) {
        throw new Error("[kobalte]: `useMenubarContext` must be used within a `Menubar` component");
    }
    return context;
}
